import AdminLayout from "./AdminLayout";

export default function AdminUsers() {
  return (
    <AdminLayout>
      <div className="admin-page-header">
        <div className="admin-eyebrow">Platform</div>
        <div className="admin-page-title">Users</div>
        <span className="admin-page-hand">— user lookup and account tools (coming next)</span>
      </div>
      <p style={{ color: "#9A9088", fontSize: 14, maxWidth: 520, lineHeight: 1.6, marginTop: 24 }}>
        This screen is wired into the admin shell. Search, role filters, and account actions
        will land here without changing the top nav or sidebar.
      </p>
    </AdminLayout>
  );
}
